import { graphql, useStaticQuery } from 'gatsby';

/**
 * Creates a canonical URL for a given path using the site's base URL.
 * Follows Google's guidelines for canonical URLs:
 * https://developers.google.com/search/docs/crawling-indexing/consolidate-duplicate-urls
 * 
 * @param {string} path - The path portion of the URL (e.g., '/about' or '/')
 * @returns {string} The full canonical URL (e.g., 'https://www.geocod.io/about')
 */
export const useCanonicalUrl = (path) => {
  const { site } = useStaticQuery(
    graphql`
      query SiteMetadataQuery {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `
  );

  const base = site.siteMetadata.siteUrl;
  // Ensure path starts with a slash if it's not the root path
  const normalizedPath = path === '/' ? '' : path.startsWith('/') ? path : `/${path}`;
  // Ensure path ends with trailing slash unless it's the root URL
  const cleanPath = normalizedPath === '' ? '' : normalizedPath.endsWith('/') ? normalizedPath : `${normalizedPath}/`;
  
  return `${base}${cleanPath}`;
};
